const DTException = Mach.requireModule('DTException');

/**
 * 获取谛听码, 异常上报参数已组装好
 * @param errCode  //异常码, API返回的异常码，或者前端自定义的异常码
 * @param errType  //异常类型，'B'-后端异常， 'F'-前端异常，'H'-网络异常，默认为后端异常
 * @param extraInfo //异常上报参数
 */
const getDTCode = (errCode: number, errType: String = 'B', extraInfo: any = {}) => {
  let dtCode = '';
  if (errCode) {
    dtCode = DTException?.dtExceptionCode?.({
      exceptionInfo: {
        code: errCode,
        type: errType || 'B',
        extraInfo
      }
    });
  }
  return dtCode;
};

/**
 * 获取谛听码，异常上报参数未组装好
 * @param errCode  //异常码, API返回的异常码，或者前端自定义的异常码
 * @param errType  //异常类型，'B'-后端异常， 'F'-前端异常，默认为后端异常
 * @param errMessage //异常信息
 * @param url        //异常接口url
 * @param method     //异常调用的方法
 */
const getDTCodeWithExtraInfo = (errCode: number, errType: string = 'B', errMessage: string = '', url: string = '', method: string = '') => {
  let dtCode = '';
  if (errCode) {
    const extraInfo: any = {};
    if (errMessage) {
      extraInfo.message = errMessage;
    }
    if (url) {
      extraInfo.url = url;
    }
    if (method) {
      extraInfo.method = method;
    }
    dtCode = DTException?.dtExceptionCode?.({
      exceptionInfo: {
        code: errCode,
        type: errType || 'B',
        extraInfo
      }
    });
  }
  return dtCode;
};

export { getDTCode, getDTCodeWithExtraInfo };
